import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'
import { format, formatParams } from './format'
import type { ApiOVPProfile } from './index.h'

export function use(
  client: OvpClient,
  profile: API['profile'],
  _api: API
): void {
  // GET /api/web/users/profile
  profile.getProfileFx.use(async () => {
    const data = payload<ApiOVPProfile>(
      await client.get.api.web.users.profile()
    )

    if (!data) {
      throw new Error('Empty answer in user.getProfileFx')
    }

    return format(data)
  })

  // POST /api/web/users/profile
  profile.setProfileFx.use(async (params) => {
    const body = formatParams(params)
    payload(await client.post.api.web.users.profile({ body }))
  })
}
